import { dateFormatter2 as dateFormatter, DateFormatTypes } from '@jfs/utils'
import { isEmpty } from '../../../../../libs/ui-new/src/utils/utils'
import { AddressType } from '../../data/models/Address'
import { Transaction, transactionStatus } from '../../data/models/Transaction'
import { MAX_TRANSACTIONS } from '../../data/static/data'

const getPageCount = (page: number) => {
  if (page === 0) {
    return 1
  }
  return page
}

const getPageSize = (size: number, totalPage: number) => {
  if (totalPage === 1) {
    return size
  }
  return size < 10 && size > 0 ? 10 : size
}

const parsePage = (page: any, restrictTransactionCount = false) => {
  const totEle =
    restrictTransactionCount && +page?.totalElements > MAX_TRANSACTIONS ? MAX_TRANSACTIONS : +page?.totalElements ?? 0
  const totPage =
    restrictTransactionCount && +page?.totalElements > MAX_TRANSACTIONS
      ? totEle / 10
      : totEle < 11
      ? 1
      : +page?.totalPages ?? 0
  const pageNumber = totEle < 11 ? 1 : getPageCount(+page?.number) ?? 0
  const pgSize = getPageSize(+page?.size ?? 0, totPage)

  return {
    size: pgSize,
    totalElements: totEle ?? 0,
    totalPages: totPage,
    number: pageNumber,
  }
}

const transactionsParser = (data: any, txntype: any): any => {
  const { content, page } = data?.data?.data
  const pageObj = parsePage(page)
  const txn = content?.map((txnItem: any) =>
    Transaction.create({
      id: txnItem?.retrievalReferenceNumber ?? 'NA',
      date: dateFormatter(txnItem?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY), // timestamp txnItem?.transactionDateTime ?? 'NA', // timestamp
      // date: txnItem?.transactionDateTime ?? 'NA', // timestamp txnItem?.transactionDateTime ?? 'NA', // timestamp
      ern: txnItem?.additionalDataNational ?? 'NA',
      rrn: txnItem?.retrievalReferenceNumber ?? 'NA',
      failureReason: isEmpty(txnItem?.failureMessage) ? 'NA' : txnItem?.failureMessage,
      amount: txnItem?.transactionAmount ?? 0, // amount as number
      status: txnItem?.transactionDisposition ?? transactionStatus.Awaited,
      bankRefNumber: txnItem?.issRefData ?? 'NA',
      type: txnItem?.transactionType ?? 'NA',
      authCode: txnItem?.authCode ?? 'NA', // Authorization Code provided by Issuer for a transaction
      acquirerTerminal: txnItem?.acquirerTerminal ?? 'NA', // Terminal ID on which the transaction was acquired
      surCharge: txnItem?.surChargeAmount ?? 0, // This is like fuel surcharge
      convenienceFeeAmount: txnItem?.conFeeAmount ?? 0, // Convenience Fee. IRCTC like merchants don’t bear the MDR. They pass it on to the customer & it is called Convenience Fee
      emiCode: txnItem?.emiInd ?? 'NA', // asked
      merchantName:
        txnItem?.merchantName?.length >= 35
          ? `${txnItem?.merchantName?.toString().substring(0, 35)}...`
          : txnItem?.merchantName ?? 'NA',
      merchantType: txnItem?.merchantType ?? 'NA', // asked
      taxOnConvenienceFee: txnItem?.totalTaxOnConvenienceFee ?? 0, // ?
      amtDebitedFromCust: txnItem?.amtDebitedFromCust ?? 0, // ?
      transactionClass: txnItem?.transactionClass ?? 'NA', // Internal code classification of transactions – like Purchase(WPP), Load Money (LMU/LMW) etc.
      txnType: txntype,
      failureMessage: txnItem?.failureMessage ?? 'NA',
      customer: {
        id: txnItem?.customerId ?? 'NA',
        name: !isEmpty(txnItem?.customerName) ? txnItem?.customerName : 'NA',
        mobileNumber: txnItem?.mobileNumber ?? 'NA',
        email: txnItem?.email ?? 'NA',
        address: {
          id: 'NA',
          type: AddressType.Residential,
          line1: txnItem?.addressLine1 ?? 'NA',
          line2: txnItem?.addressLine2 ?? 'NA',
          pincode: txnItem?.pin ?? 'NA',
          city: 'NA',
          state: txnItem?.state ?? 'NA',
          country: 'NA',
        },
      },
      payment: {
        paymentMode: txnItem?.cardType ?? 'NA',
        paymentType: txnItem?.paymentType ?? 'NA',
        accountNumber: txnItem?.accountNumber ?? 'NA',
        cardCountryCode: txnItem?.issCountryCode ?? 'NA',
        cardLogoId: txnItem?.cardLogoId ?? 'NA',
      },
      disputes: {
        chargeBackReasonCode: txnItem?.chargeBackReason ?? 'NA',
        chargeBackDate: dateFormatter(txnItem?.chargeBackDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
        replyBeforeDate: dateFormatter(txnItem?.replyBeforeDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
      },
      offer: {
        merchantOfferRefId: txnItem?.merchantOfferRefId ?? 'NA',
        offerKey: txnItem?.offerKey ?? 'NA',
        instantDiscountAmount: txnItem?.instantDiscountAmount ?? 0,
        instantDiscountStatus: txnItem?.instantDiscountStatus ?? 'NA',
        cashBackAmount: txnItem?.cashbackAmount ?? 0,
        cashbackStatus: txnItem?.cashbackStatus ?? 'NA',
        offerCompolsoryFlag: txnItem?.offerCompolsoryFlag ?? false,
        offerTransactionAmount: txnItem?.offerTransactionAmount ?? 0,
        offerReferenceId: txnItem?.offerReferenceId ?? 'NA',
        offerCode: txnItem?.offerCode ?? 'NA',
      },
      refund: {
        amount: txnItem?.refundAmount ?? 0,
        pending: txnItem?.refundPending ?? 0,
        requestedDate: dateFormatter(txnItem?.refundRequestedDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
        processdDate: dateFormatter(txnItem?.refundProcessdDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
        status: txnItem?.refundStatus ?? 'NA',
        refundMessage: txnItem?.refundMessage ?? 'NA',
        processed: '',
      },
      settlementDetails: {
        referenceNumber: txnItem?.settlementRefNumber ?? 'NA',
        status: txnItem?.settlementStatus ?? 'NA',
        fileName: txnItem?.fileName ?? 'NA',
        neftNumber: txnItem?.neftNumber ?? 'NA',
        commisionCharge: txnItem?.commissionCharged ?? 0,
        totalTaxOnCommission: txnItem?.totalTaxOnCommission ?? 0,
        settledAmount: txnItem?.settledAmount ?? 0,
        date: dateFormatter(txnItem?.settlementDate ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
      },
      refundHistory:
        txnItem.refundHistory?.map((item: any) => ({
          trxAmount: item?.txnAmount ?? 0,
          refundAmount: item?.refundAmount ?? 0,
          initiatedDate: dateFormatter(item?.initiatedDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
          status: item?.status ?? 'NA',
          processedOn: item?.processedOn ?? 'NA',
        })) ?? [],
    }),
  )
  return { transaction: txn, page: pageObj }
}

const transactionsParserV3 = (data: any, txntype: any, restrictTransactionCount: boolean = false): any => {
  const { content, page } = data?.data?.data
  const pageObj = parsePage(page, restrictTransactionCount)
  const txn = content?.map((txnItem: any) =>
    Transaction.create({
      id: txnItem?.transactionId ?? 'NA', //V3 change
      date: `${dateFormatter(txnItem?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY)}*${
        txnItem?.transactionDateTime
      }`, //Storing both formats needed for LIST UI and to send in API separated by *
      timestamp: dateFormatter(txnItem?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
      ern: txnItem?.invoice ?? 'NA', //V3 change
      rrn: txnItem?.transactionId ?? 'NA', //V3 change
      failureReason: isEmpty(txnItem?.failureMessage) ? 'NA' : txnItem?.failureMessage,
      amount: txnItem?.transactionAmount ?? 0, // amount as number
      status: txnItem?.transactionDisposition ?? transactionStatus.Awaited,
      bankRefNumber: txnItem?.issRefData ?? 'NA',
      type: txnItem?.transactionType ?? 'NA',
      authCode: txnItem?.authCode ?? 'NA', // Authorization Code provided by Issuer for a transaction
      acquirerTerminal: txnItem?.acquirerTerminal ?? 'NA', // Terminal ID on which the transaction was acquired
      surCharge: txnItem?.surChargeAmount ?? 0, // This is like fuel surcharge
      convenienceFeeAmount: txnItem?.conFeeAmount ?? 0, // Convenience Fee. IRCTC like merchants don’t bear the MDR. They pass it on to the customer & it is called Convenience Fee
      emiCode: txnItem?.emiInd ?? 'NA', // asked
      merchantName:
        txnItem?.merchantName?.length >= 35
          ? `${txnItem?.merchantName?.toString().substring(0, 35)}...`
          : txnItem?.merchantName ?? 'NA',
      merchantType: txnItem?.merchantType ?? 'NA', // asked
      taxOnConvenienceFee: txnItem?.totalTaxOnConvenienceFee ?? 0, // ?
      amtDebitedFromCust: txnItem?.amtDebitedFromCust ?? 0, // ?
      transactionClass: txnItem?.transactionClass ?? 'NA', // Internal code classification of transactions – like Purchase(WPP), Load Money (LMU/LMW) etc.
      txnType: txntype,
      failureMessage: txnItem?.failureMessage ?? 'NA',
      customer: {
        id: txnItem?.customerId ?? 'NA',
        name: !isEmpty(txnItem?.customerName) ? txnItem?.customerName : 'NA',
        mobileNumber: txnItem?.mobileNumber ?? 'NA',
        email: txnItem?.email ?? 'NA',
        address: {
          id: 'NA',
          type: AddressType.Residential,
          line1: txnItem?.addressLine1 ?? 'NA',
          line2: txnItem?.addressLine2 ?? 'NA',
          pincode: txnItem?.pin ?? 'NA',
          city: 'NA',
          state: txnItem?.state ?? 'NA',
          country: 'NA',
        },
      },
      payment: {
        paymentMode: txnItem?.cardType ?? 'NA',
        paymentType: txnItem?.paymentType ?? 'NA',
        accountNumber: txnItem?.accountNumber ?? 'NA',
        cardCountryCode: txnItem?.issCountryCode ?? 'NA',
        cardLogoId: txnItem?.cardLogoId ?? 'NA',
      },
      disputes: {
        chargeBackReasonCode: txnItem?.chargeBackReason ?? 'NA',
        chargeBackDate: dateFormatter(txnItem?.chargeBackDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
        replyBeforeDate: dateFormatter(txnItem?.replyBeforeDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
      },
      offer: {
        merchantOfferRefId: txnItem?.merchantOfferRefId ?? 'NA',
        offerKey: txnItem?.offerKey ?? 'NA',
        instantDiscountAmount: txnItem?.instantDiscountAmount ?? 0,
        instantDiscountStatus: txnItem?.instantDiscountStatus ?? 'NA',
        cashBackAmount: txnItem?.cashbackAmount ?? 0,
        cashbackStatus: txnItem?.cashbackStatus ?? 'NA',
        offerCompolsoryFlag: txnItem?.offerCompolsoryFlag ?? false,
        offerTransactionAmount: txnItem?.offerTransactionAmount ?? 0,
        offerReferenceId: txnItem?.offerReferenceId ?? 'NA',
        offerCode: txnItem?.offerCode ?? 'NA',
      },
      refund: {
        amount: txnItem?.refundAmount ?? 0,
        pending: txnItem?.refundPending ?? 0,
        requestedDate: dateFormatter(txnItem?.refundRequestedDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
        processdDate: dateFormatter(txnItem?.refundProcessdDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
        status: txnItem?.refundStatus ?? 'NA',
        refundMessage: txnItem?.refundMessage ?? 'NA',
        processed: '',
        sourceSystem: txnItem?.sourceSystem ?? '',
      },
      settlementDetails: {
        referenceNumber: txnItem?.settlementRefNumber ?? 'NA',
        status: txnItem?.settlementStatus ?? 'NA',
        fileName: txnItem?.fileName ?? 'NA',
        neftNumber: txnItem?.neftNumber ?? 'NA',
        commisionCharge: txnItem?.commissionCharged ?? 0,
        totalTaxOnCommission: txnItem?.totalTaxOnCommission ?? 0,
        settledAmount: txnItem?.settledAmount ?? 0,
        date: dateFormatter(txnItem?.settlementDate ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
      },
      refundHistory:
        txnItem.refundHistory?.map((item: any) => ({
          trxAmount: item?.txnAmount ?? 0,
          refundAmount: item?.refundAmount ?? 0,
          initiatedDate: dateFormatter(item?.initiatedDate ?? 'NA', DateFormatTypes.DATE_AM_PM),
          status: item?.status ?? 'NA',
          processedOn: item?.processedOn ?? 'NA',
        })) ?? [],
      convenienceFee: {
        amount: txnItem?.convenienceFee ? txnItem?.convenienceFee : '0',
        originalTxnAmt: txnItem?.originalTxnAmt ? txnItem?.originalTxnAmt : '0',
        cgst: txnItem?.convFeeCgst ? txnItem?.convFeeCgst : '0',
        sgst: txnItem?.convFeeSgst ? txnItem?.convFeeSgst : '0',
        igst: txnItem?.convFeeIgst ? txnItem?.convFeeIgst : '0',
        ugst: txnItem?.convFeeUgst ? txnItem?.convFeeUgst : '0',
      },
    }),
  )
  return { transaction: txn, page: pageObj }
}
export const transactionsParserV3New = (data: any, txnType: any, restrictTransactionCount: boolean = false): any => {
  const { content, page } = data?.data?.data
  const pageObj = parsePage(page, restrictTransactionCount)
  const txn = content?.map((txnItem: any) => ({
    ...txnItem,
    txnType,
    transactionDateTime: `${dateFormatter(txnItem?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY)}`,
    timestamp: dateFormatter(txnItem?.transactionDateTime ?? 'NA', DateFormatTypes.DATE_ONLY_WITHOUT_TIME),
  }))
  return { transaction: txn, page: pageObj }
}

export { parsePage, transactionsParser, transactionsParserV3 }
//transactionAmount: `₹ ${numberToLocalString(Number(txnItem?.transactionAmount))}`,
